import { PATH_DASHBOARD } from 'src/routes/paths';

// The console is addressed by PMS appointment id. The lead id and the appointment
// start travel in the query so the page can fetch the right diary day and patient
// without a new backend endpoint; neither is a secret and neither is trusted —
// the page re-reads the appointment from the diary before showing anything.
// The practice-scoped group is `PATH_DASHBOARD.user` in this codebase; its URLs
// live under /dashboard/practice/.
// `instant` marks an accepted "Talk now" call: the console joins it straight away.
export const consoleUrl = (appointmentId, { leadId, startAt, instant = false } = {}) => {
  const query = new URLSearchParams();
  if (Number(leadId) > 0) query.set('lead', String(Number(leadId)));
  if (typeof startAt === 'string' && startAt) query.set('start', startAt);
  if (instant) query.set('instant', '1');
  const search = query.toString();
  return `${PATH_DASHBOARD.user.consultation(encodeURIComponent(String(appointmentId)))}${search ? `?${search}` : ''}`;
};

export const parseConsoleQuery = (search) => {
  const params = new URLSearchParams(typeof search === 'string' ? search.replace(/^\?/, '') : '');
  const lead = Number(params.get('lead'));
  const start = params.get('start');
  return {
    leadId: Number.isInteger(lead) && lead > 0 ? lead : null,
    startAt: typeof start === 'string' && start ? start : null,
    instant: params.get('instant') === '1',
  };
};
